import { useRef } from 'react'

// Closes the modal only when both the mousedown and the click land directly on the overlay (not
// bubbled up from a descendant). Without this, starting a text selection or drag inside the modal
// and releasing the mouse over the overlay closes it too — the click's target is the nearest
// common ancestor of the mousedown/mouseup targets, which is the overlay itself in that case.
export function useOverlayClose(onClose) {
  const mouseDownOnOverlayRef = useRef(false)

  return {
    onMouseDown: (e) => {
      mouseDownOnOverlayRef.current = e.target === e.currentTarget
    },
    onClick: (e) => {
      if (mouseDownOnOverlayRef.current && e.target === e.currentTarget) onClose()
    },
  }
}
